// 模組07 訊息功能 — 通知暫停規則 mock 種子資料(ticket 13)。
//
// 暫停以「來源模組 × 型別」為單位,不再是單筆通知的靜音旗標。
// 建立與解除都要送三關審核,`active` 只在核准後才由審核引擎(mock/approvals.js
// 的 APPLY_BY_ACTION)寫入,前端不自己切這個欄位。
//   source/type  比對鍵,對應 notifications 的 source/type
//   active       是否生效中(唯一由審核通過後回寫的欄位)
//   approvalStatus  最近一張審核單的狀態(pending/approved/rejected)
export const notifyMuteRules = [
  {
    id: 1,
    source: "資產管理",
    type: "CVE",
    active: true,
    approvalStatus: "approved",
    createdBy: "王志明（總經理室）",
    createdAt: "2026-07-05T09:00:00+08:00",
  },
];
